import * as Sentry from "@sentry/react";

class Crashlitics {
  private static isDevEnv = import.meta.env.DEV;

  static init() {
    if (Crashlitics.isDevEnv) return;

    const dsn = import.meta.env.VITE_SENTRY_URL;

    if (!dsn) {
      throw new Error("SENTRY_DNS is not set");
    }

    Sentry.init({
      dsn,
      sendDefaultPii: true,
    });
  }

  static identifyUser(id: string, email: string) {
    if (Crashlitics.isDevEnv) return;

    Sentry.setUser({ id, email });
  }

  static captureException(error: unknown) {
    if (Crashlitics.isDevEnv) return;

    Sentry.captureException(error);
  }

  static captureMessage(message: string) {
    if (Crashlitics.isDevEnv) return;

    Sentry.captureMessage(message);
  }
}

export default Crashlitics;
